import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import InputMask from 'react-input-mask';

import {
  SignUpContainer,
  CheckboxContainer,
  Form,
  ButtonPassword,
  ButtonRegister,
  InputWrapper,
  Label,
  Underline,
  Input,
  InputContainer,
  Logomarca,
  Imgs
} from '../styles';
import { getCep, signUp } from '../api';

function SignUpForm() {
  const [formData, setFormData] = useState({
    fullName: '',
    email: '',
    cpf: '',
    cep: '',
    phone: '',
    cref: '',
    cnpj: '',
    noCref: false, 
    address: '',
    neighborhood: '',
    city: '',
    complement: '',
    username: '',
    password: '',
    confirmPassword: '',
    passwordsMatch: true,
    passwordLengthValid: false,
    passwordUpperCaseValid: false,
    passwordNumberValid: false,
    passwordSpecialCharValid: false,
    addressFetched: false,
  });

  const [errorMessages, setErrorMessages] = useState({
    email: '',
    phone: '',
    cpf: '',
    username: '',
    general: '', 
  });

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);
  const [showPasswordRules, setShowPasswordRules] = useState(false);
  const [isProfessor, setIsProfessor] = useState(false);
  const [usernameError, setUsernameError] = useState(''); // Estado para a mensagem de erro
  const [isChecked, setIsChecked] = useState(false);

  const navigate = useNavigate();

  const fetchAddressFromCEP = async (cep) => {
    try {

      const response = await getCep(cep);

      if (!response.ok) {
        throw new Error('Erro ao buscar o endereço. Por favor, verifique o CEP e tente novamente.');
      }

      const data = await response.json();

      return data;

    } catch (error) {
      console.error('Erro ao buscar o endereço:', error);
      return null;
    }
  };

  const handleCEPChange = async (e) => {
    const { value } = e.target;
    const numericValue = value.replace(/\D/g, '');

    setFormData({
      ...formData,
      cep: numericValue
    });

    if (numericValue.length === 8) {
      const addressData = await fetchAddressFromCEP(numericValue);
      if (addressData) {
        setFormData({
          ...formData,
          addressFetched: true,
          cep: numericValue,
          address: addressData.logradouro,
          neighborhood: addressData.bairro,
          city: addressData.localidade,
        });
      }
    }
  };

  const validatePassword = (password) => {
    const passwordLengthValid = password.length >= 6;
    const passwordUpperCaseValid = /[A-Z]/.test(password);
    const passwordNumberValid = /[0-9]/.test(password);
    const passwordSpecialCharValid = /[!@#$%^&*(),.?":{}|<>]/.test(password);

    return {
      passwordLengthValid,
      passwordUpperCaseValid,
      passwordNumberValid,
      passwordSpecialCharValid
    };
  };

  const handleChange = (e) => {
  const { name, value } = e.target;

  if (name === 'username') {
    let errorMessage = '';
    
    // Verificar caracteres inválidos
    const invalidChars = value.match(/[^a-z0-9_.-]/g);
    if (invalidChars) {
      invalidChars.forEach((char) => {
        if (/[A-Z]/.test(char)) {
          errorMessage = 'Letras maiúsculas não são permitidas.';
        } else if (/[\s]/.test(char)) {
          errorMessage = 'Espaços não são permitidos.';
        } else {
          errorMessage = `O caractere '${char}' não é permitido.`;
        }
      });
    }
    setUsernameError(errorMessage);
  }

  setFormData({
    ...formData,
    [name]: value,
  });

  if (name === 'password') {
    setShowPasswordRules(true);
    const validation = validatePassword(value);
    setFormData({
      ...formData,
      password: value,
      ...validation
    });
  }

  if (name === 'confirmPassword') {
    setFormData({
      ...formData,
      passwordsMatch: value === formData.password,
      confirmPassword: value
    });
  }

  if (name === 'cref') {
    setFormData({
      ...formData,
      cref: value
    });
  }
};

  const handleSubmit = async (e) => {
    e.preventDefault();

    // Verifica se o usuário é professor e não informou o CREF
    if (isProfessor && !formData.noCref && !formData.cref) {
      setErrorMessages({
        ...errorMessages,
        general: 'Por favor, informe seu CREF ou marque a opção "Não possuo CREF".'
      });
      return; // Interrompe a submissão se a validação falhar
    }

    if (formData.password !== formData.confirmPassword) {
      setFormData({
        ...formData,
        passwordsMatch: false
      });
      return;
    }

    const formDataToSend = {
      fullName: formData.fullName,
      email: formData.email,
      cpf: formData.cpf.replace(/\D/g, ''), 
      cep: formData.cep,
      phone: formData.phone.replace(/\D/g, ''), 
      cref: isProfessor && !formData.noCref ? formData.cref : null, // Envia o CREF se o usuário for professor e tiver um
      noCref: isProfessor && formData.noCref, // Envia true se o usuário for professor e não tiver CREF
      cnpj: formData.cnpj,
      address: formData.address,
      neighborhood: formData.neighborhood,
      city: formData.city,
      complement: formData.complement,
      username: formData.username,
      password: formData.password,
    };

    console.log("Dados do formulário a serem enviados:", formDataToSend);

    try {

      const response = await signUp(formDataToSend);

      if (response.ok) {
        navigate('/register-success');

      } else {
        const errorData = await response.json();
        console.error('Erro ao cadastrar:', errorData);

        const newErrorMessages = {
          email: errorData.email || '',
          phone: errorData.phone || '',
          cpf: errorData.cpf || '',
          username: errorData.username || '',
          general: errorData.message || '' 
        };

        setErrorMessages(newErrorMessages);
      }

    } catch (error) {
      console.error('Erro:', error);
      setErrorMessages({
        ...errorMessages,
        general: 'Ocorreu um erro inesperado. Por favor, tente novamente mais tarde.'
      });
    }
  };

  const handlePhoneChange = (e) => {
    const { value } = e.target;
    setFormData({
      ...formData,
      phone: value
    });
  };

  const allPasswordValid = formData.passwordLengthValid &&
    formData.passwordUpperCaseValid &&
    formData.passwordNumberValid &&
    formData.passwordSpecialCharValid;

  return (
    <SignUpContainer>
      <InputContainer>
        <Logomarca src={Imgs.logo} alt="Logo da Minha Empresa" width="200px" height="auto" />
        <Form onSubmit={handleSubmit}>
          <InputWrapper>
            <Label>NOME COMPLETO</Label>
            <Input
              style={{padding: '0'}}
              type="text"
              name="fullName"
              placeholder="seu nome completo"
              value={formData.fullName}
              onChange={handleChange}
            />
            <Underline />
          </InputWrapper>
          <InputWrapper>
            <Label>USERNAME</Label>
            <Input
              style={{padding: '0'}}
              type="text"
              name="username"
              placeholder="username"
              value={formData.username}
              onChange={handleChange}
            />
            <Underline />
            {usernameError && <p style={{ color: 'red', fontSize: '0.9em' }}>{usernameError}</p>}
          </InputWrapper>
          <InputWrapper>
            <Label>E-MAIL</Label>
            <Input
              style={{padding: '0'}}
              type="email"
              name="email"
              placeholder="seuemail@email.com"
              value={formData.email}
              onChange={handleChange}
            />
            <Underline />
            {errorMessages.email && <div style={{ color: 'red' }}>{errorMessages.email}</div>}
          </InputWrapper>
          <InputWrapper>
            <Label>TELEFONE</Label>
            <InputMask
              mask="(99)99999-9999"
              value={formData.phone}
              onChange={handlePhoneChange}
            >
              {(inputProps) => (
                <Input
                  {...inputProps}
                  style={{padding: '0'}}
                  type="text"
                  name="phone"
                  placeholder="(xx)xxxxx-xxxx"
                />
              )}
            </InputMask>
            <Underline />
            {errorMessages.phone && <div style={{ color: 'red' }}>{errorMessages.phone}</div>}
          </InputWrapper>
          <InputWrapper>
            <Label>CPF</Label>
            <InputMask
              style={{padding: '0'}}
              mask="999.999.999-99"
              placeholder="xxx.xxx.xxx-xx"
              value={formData.cpf}
              onChange={(e) => setFormData({ ...formData, cpf: e.target.value })}
            >
              {(inputProps) => <Input {...inputProps} />}
            </InputMask>
            <Underline />
            {errorMessages.cpf && <div style={{ color: 'red' }}>{errorMessages.cpf}</div>}
          </InputWrapper>
          <InputWrapper>
            <Label>CEP</Label>
            <InputMask
              style={{padding: '0'}}
              mask="99.999-999"
              placeholder="xx.xxx-xxx"
              value={formData.cep}
              onChange={(e) => setFormData({ ...formData, cep: e.target.value })}
              onInput={handleCEPChange}
            >
              {(inputProps) => <Input {...inputProps} />}
            </InputMask>
            <Underline />
          </InputWrapper>
          {formData.addressFetched && (
            <>
              <InputWrapper>
                <Label>ENDEREÇO</Label>
                <Input
                  style={{padding: '0'}}
                  type="text"
                  name="address"
                  placeholder="endereço"
                  value={formData.address}
                  readOnly
                />
                <Underline />
              </InputWrapper>
              <InputWrapper>
                <Label>BAIRRO</Label>
                <Input
                  style={{padding: '0'}}
                  type="text"
                  name="neighborhood"
                  placeholder="bairro"
                  value={formData.neighborhood}
                  readOnly
                />
                <Underline />
              </InputWrapper>
              <InputWrapper>
                <Label>CIDADE</Label>
                <Input
                  style={{padding: '0'}}
                  type="text"
                  name="city"
                  placeholder="cidade"
                  value={formData.city}
                  readOnly
                />
                <Underline />
              </InputWrapper>
            </>
          )}
          <InputWrapper>
            <Label>
              <input
                style={{cursor: 'pointer'}}
                type="checkbox"
                checked={isProfessor}
                onChange={() => setIsProfessor(!isProfessor)} 
              />
              SOU PROFESSOR
            </Label>
          </InputWrapper>
          {isProfessor && (
            <>
              <InputWrapper>
                <Label>CREF (Obrigatório para professores)</Label>
                <Input
                  style={{padding: '0'}}
                  type="text"
                  name="cref"
                  placeholder="seu CREF"
                  value={formData.cref}
                  onChange={handleChange}
                />
                <Underline />
              </InputWrapper>
              <InputWrapper>
                <Label>CNPJ (Obrigatório para professores)</Label>
                <Input
                  style={{padding: '0'}}
                  type="text"
                  name="cnpj"
                  placeholder="seu CNPJ"
                  value={formData.cnpj}
                  onChange={handleChange}
                />
                <Underline />
              </InputWrapper>
            </>
          )}
          <InputWrapper>
            <Label>
              <input
                style={{ cursor: 'pointer' }}
                type="checkbox"
                checked={formData.noCref}
                onChange={() =>
                  setFormData({
                    ...formData,
                    noCref: !formData.noCref,
                    cref: '', // Limpa o campo CREF ao marcar o checkbox
                  })
                }
              />
              SOU PROFESSOR E NÃO POSSUO CREF
            </Label>
            {formData.noCref && (
              <>
                <div style={{ color: 'orange', fontSize: '0.9em', marginBottom: '40px' }}>
                  Cadastro pendente de aprovação
                </div>
                <InputWrapper>
                  <Label>CNPJ (Obrigatório para professores)</Label>
                  <Input
                    style={{ padding: '0' }}
                    type="text"
                    name="cnpj"
                    placeholder="seu CNPJ"
                    value={formData.cnpj}
                    onChange={handleChange}
                  />
                  <Underline />
                </InputWrapper>
              </>
            )}
          </InputWrapper>
          <InputWrapper>
            <Label>SENHA</Label>
            <Input
              style={{padding: '0'}}
              type={showPassword ? 'text' : 'password'}
              name="password"
              placeholder="********"
              value={formData.password}
              onChange={handleChange}
            />
            <Underline />
            <ButtonPassword
              type="button"
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? 'Ocultar' : 'Mostrar'}
            </ButtonPassword>
            {showPasswordRules && (
              <div style={{ color: 'red' }}>
                <ul>
                  <li style={{ color: formData.passwordLengthValid ? 'green' : 'red' }}>6 caracteres mínimos</li>
                  <li style={{ color: formData.passwordUpperCaseValid ? 'green' : 'red' }}>1 letra maiúscula</li>
                  <li style={{ color: formData.passwordNumberValid ? 'green' : 'red' }}>1 número</li>
                  <li style={{ color: formData.passwordSpecialCharValid ? 'green' : 'red' }}>1 caractere especial</li>
                </ul>
              </div>
            )}
          </InputWrapper>
          <InputWrapper>
            <Label>CONFIRMAR SENHA</Label>
            <Input
              style={{padding: '0'}}
              type={showConfirmPassword ? 'text' : 'password'}
              name="confirmPassword"
              placeholder="********"
              value={formData.confirmPassword}
              onChange={handleChange}
            />
            <Underline />
            <ButtonPassword
              type="button"
              onClick={() => setShowConfirmPassword(!showConfirmPassword)}
            >
              {showConfirmPassword ? 'Ocultar' : 'Mostrar'}
            </ButtonPassword>
            {!formData.passwordsMatch && (
              <div style={{ color: 'red' }}>As senhas não coincidem.</div>
            )}
          </InputWrapper>
          <InputWrapper>
            <CheckboxContainer>
          <input
            type="checkbox"
            id="termsCheckbox"
            checked={isChecked}
            onChange={(e) => setIsChecked(e.target.checked)}
            style={{cursor: "pointer"}}
          />
          <label htmlFor="termsCheckbox" style={{color: "white"}}>
            Ao marcar o checkbox deixo claro que aceito os{' '}
              <a
              href="/termos-de-uso.pdf"
              target="_blank"
              rel="noopener noreferrer"
              style={{ color: '#007bff', textDecoration: 'underline' }}
              >
              termos de uso
              </a>
          </label>
        </CheckboxContainer>
          </InputWrapper>
          <ButtonRegister
            type="submit"
            onClick={handleSubmit}
            disabled={!allPasswordValid || !formData.passwordsMatch || !isChecked}>
            CADASTRAR
          </ButtonRegister>
          {errorMessages.general && <div style={{ color: 'red' }}>{errorMessages.general}</div>}
        </Form>
      </InputContainer>
    </SignUpContainer>
  );
}

export default SignUpForm;
